import { render, staticRenderFns } from "./MainTabEvents.vue?vue&type=template&id=09318b0f&"
import script from "./MainTabEvents.vue?vue&type=script&lang=js&"
export * from "./MainTabEvents.vue?vue&type=script&lang=js&"
import style0 from "./MainTabEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports